import { useGetChangedSections } from "./use-get-changed-sections";

export function useShouldShowLawZoomAction(): boolean {
  const { data: changedSections } = useGetChangedSections();
  return Boolean(changedSections && changedSections.length > 0);
}
